export async function processValidation({ contactSupportReasonType, doAction }) {
  try {
    const validation = await doAction()

    return {
      contactSupportReasonType,
      value: validation.result,
      displayError: validation.reason,
      error: null,
    }
  } catch (error) {
    return {
      contactSupportReasonType,
      value: false,
      error,
      displayError:
        'Error al procesar lo datos, por favor intente nuevamente o contáctese con nosotros.',
    }
  }
}
